var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoveD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "move-d",
    transform: "translate(-197 -888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5324",
    "data-name": "Rectangle 5324",
    transform: "translate(197 888)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_52_7",
    "data-name": "Component 52 \\u2013 7",
    transform: "translate(206 893)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5 16) rotate(90)",
    fill: "#dcdeea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(13 16) rotate(90)",
    fill: "#dcdeea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5 8) rotate(90)",
    fill: "#dcdeea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(13 8) rotate(90)",
    fill: "#dcdeea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5) rotate(90)",
    fill: "#dcdeea"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(13) rotate(90)",
    fill: "#dcdeea"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveD);
export default __webpack_public_path__ + "static/media/move-d.531394962a619bc643f643d0c01d7612.svg";
export { ForwardRef as ReactComponent };